// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fullscreen dark overlay */
.product-recall-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 2rem;
  z-index: 9999;
}

/* Modal card */
.product-recall-modal__content {
  background: #ffffff;
  width: 100%;
  height: 100%;
  max-width: 800px;
  overflow-y: auto;
  padding: 5rem 5rem 3rem 5rem;
  border-radius: 5px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.5);
  color: #111111;
  font-size: 14px;
  line-height: 1.5;
  position: relative;
  border-top: 10px solid #ff4a00;
  box-sizing: border-box;
  position: relative;
}

.product-recall-modal__content hr {
  border: none;
  border-top: 1px solid #a7a7a7ff;
  margin: 2rem 0;
}

/* Small fade at the bottom */
.product-recall-modal__content::after {
  content: "";
  position: sticky;
  bottom: 0;
  transform: translateY(3rem);
  left: 0;
  width: 100%;
  display: block;
  height: 3rem; /* height of the fade */
  margin-top: -3rem; /* does not take up space in the layout */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    #ffffff
  );
  pointer-events: none; /* does not block clicks */
}

.product-recall-modal__content img{
  width: 100%;
  height: auto;
  margin: 2rem 0 0 0;
}

/* Close button */
.product-recall-modal__close {
  position: absolute;
  top: 16px;
  right: 20px;
  border: none;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  color: #333333;
  transition: color 0.15s ease;
}

.product-recall-modal__close:hover,
.product-recall-modal__close:focus {
  color: #ff4a00;
}

/* Headings – closer to the page style */
.product-recall-modal__content h2 {
  margin: 0 48px 16px 0; /* space for the close button */
  font-size: 24px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.product-recall-modal__content h3 {
  margin-top: 24px;
  margin-bottom: 8px;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

/* Lists & text */
.product-recall-modal__content p {
  margin: 0 0 12px;
}

.product-recall-modal__content ul,
.product-recall-modal__content ol {
  padding-left: 20px;
  margin: 0 0 16px;
}

.product-recall-modal__content li + li {
  margin-top: 4px;
}

/* Note text at bottom */
.product-recall-modal__note {
  margin-top: 16px;
  font-size: 14px;
  color: #555555;
}

/* Links in modal */
.product-recall-modal__content a {
  color: #ff4a00;
  text-decoration: none;
}

.product-recall-modal__content a:hover,
.product-recall-modal__content a:focus {
  text-decoration: underline;
}

/* Mobile tweaks */
@media (max-width: 768px) {
  .product-recall-modal {
    padding: 4vh 8px;
  }

  .product-recall-modal__content {
    padding: 4rem 1.25rem 2rem 1.25rem;
  }

  .product-recall-modal__content img{
    margin: 1rem 0 0 0;
  }

  .product-recall-modal__content::after {
    bottom: 0;
    transform: translateY(2rem);
  }

  .product-recall-modal__content h2 {
    font-size: 20px;
    margin-right: 32px;
  }

  .product-recall-modal__content h3 {
    font-size: 16px;
  }

  .product-recall-modal__close {
    top: 10px;
    right: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductRecallModal.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,OAAO;EACP,WAAW;EACX,cAAc;EACd,YAAY,EAAE,uBAAuB;EACrC,iBAAiB,EAAE,yCAAyC;EAC5D;;;;GAIC;EACD,oBAAoB,EAAE,0BAA0B;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,qBAAqB,EAAE,+BAA+B;EACtD,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF","sourcesContent":["/* Fullscreen dark overlay */\n.product-recall-modal {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 2rem;\n  z-index: 9999;\n}\n\n/* Modal card */\n.product-recall-modal__content {\n  background: #ffffff;\n  width: 100%;\n  height: 100%;\n  max-width: 800px;\n  overflow-y: auto;\n  padding: 5rem 5rem 3rem 5rem;\n  border-radius: 5px;\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.5);\n  color: #111111;\n  font-size: 14px;\n  line-height: 1.5;\n  position: relative;\n  border-top: 10px solid #ff4a00;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.product-recall-modal__content hr {\n  border: none;\n  border-top: 1px solid #a7a7a7ff;\n  margin: 2rem 0;\n}\n\n/* Small fade at the bottom */\n.product-recall-modal__content::after {\n  content: \"\";\n  position: sticky;\n  bottom: 0;\n  transform: translateY(3rem);\n  left: 0;\n  width: 100%;\n  display: block;\n  height: 3rem; /* height of the fade */\n  margin-top: -3rem; /* does not take up space in the layout */\n  background: linear-gradient(\n    to bottom,\n    rgba(255, 255, 255, 0),\n    #ffffff\n  );\n  pointer-events: none; /* does not block clicks */\n}\n\n.product-recall-modal__content img{\n  width: 100%;\n  height: auto;\n  margin: 2rem 0 0 0;\n}\n\n/* Close button */\n.product-recall-modal__close {\n  position: absolute;\n  top: 16px;\n  right: 20px;\n  border: none;\n  background: transparent;\n  font-size: 28px;\n  line-height: 1;\n  cursor: pointer;\n  color: #333333;\n  transition: color 0.15s ease;\n}\n\n.product-recall-modal__close:hover,\n.product-recall-modal__close:focus {\n  color: #ff4a00;\n}\n\n/* Headings – closer to the page style */\n.product-recall-modal__content h2 {\n  margin: 0 48px 16px 0; /* space for the close button */\n  font-size: 24px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.product-recall-modal__content h3 {\n  margin-top: 24px;\n  margin-bottom: 8px;\n  font-size: 18px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n/* Lists & text */\n.product-recall-modal__content p {\n  margin: 0 0 12px;\n}\n\n.product-recall-modal__content ul,\n.product-recall-modal__content ol {\n  padding-left: 20px;\n  margin: 0 0 16px;\n}\n\n.product-recall-modal__content li + li {\n  margin-top: 4px;\n}\n\n/* Note text at bottom */\n.product-recall-modal__note {\n  margin-top: 16px;\n  font-size: 14px;\n  color: #555555;\n}\n\n/* Links in modal */\n.product-recall-modal__content a {\n  color: #ff4a00;\n  text-decoration: none;\n}\n\n.product-recall-modal__content a:hover,\n.product-recall-modal__content a:focus {\n  text-decoration: underline;\n}\n\n/* Mobile tweaks */\n@media (max-width: 768px) {\n  .product-recall-modal {\n    padding: 4vh 8px;\n  }\n\n  .product-recall-modal__content {\n    padding: 4rem 1.25rem 2rem 1.25rem;\n  }\n\n  .product-recall-modal__content img{\n    margin: 1rem 0 0 0;\n  }\n\n  .product-recall-modal__content::after {\n    bottom: 0;\n    transform: translateY(2rem);\n  }\n\n  .product-recall-modal__content h2 {\n    font-size: 20px;\n    margin-right: 32px;\n  }\n\n  .product-recall-modal__content h3 {\n    font-size: 16px;\n  }\n\n  .product-recall-modal__close {\n    top: 10px;\n    right: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
